import {
    actionCall,
    delay,
    getSession,
    getUrl,
    initSummaryComponents,
    isDesktop,
    isMobile,
    isRtl,
    openWithParams,
    refresh,
    setSession
} from "./main_ptx";
import {bulkResolve, msgResolve} from "./main_resolver";
import {getFunction} from "./main_system";
import {btn} from "./main_html";

export const groupOptions = {
    1: 'baseIcoName',
    2: 'color',
    3: 'userGroupName',
    4: 'orderDestination'
};

var e = 0;
export const summaryColSettings = {
    'id': {
        'className': 'text-center hidden-xs',
    },

    'identification' : {
        'className': 'text-right hidden-xs',
        'render': function (data, type, row) {
            return `${row.identifierTypeShortcut}: ${row.identification}`;
        },
    },

    'move_state': {
        'width': '43px',
        'className': 'text-center w43',
        'render': function (data, type, row) {
            e++;
            return Ptx.tables.renderStatus(row);
        }
    },

    'trip_duration': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return (row.lastTripPeriod) ? row.lastTripPeriod : "";
        }
    },

    'idling_duration': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return (row.lastIdlingPeriod) ? row.lastIdlingPeriod : "";
        }
    },

    'state_icon': {
        'width': '40px',
        'className': 'text-center w40',
        'render': function (data, type, row) {
            var urlPath, css = '', html = '', title = '';

            if (row.vehicleState === 'BUSINESS') {
                css = 'text-business';
            }
            if (row.vehicleState === 'PRIVATE') {
                css = 'text-private';
            }
            if (row.vehicleState === 'ALARM') {
                css = 'text-alarm anim-flicker';
            }

            var vehicleIcon = '<div class="summary-vehicle">';
            vehicleIcon += `<div class="pull-left summary-vehicle-content" style="border-left: 3px solid ${"#" + row.color};"></div>`;
            vehicleIcon += `<i class="summary-vehicle-icon icon-${row.icoName} ${css}" data-bs-toggle="tooltip" data-placement="bottom"></i></div>`;

            if (!row.inPrivateTrip || row.canSeePrivateData) {
                html += `<span class="hidden">${row.icoName}</span>`;

                urlPath = Ptx.url(`/vehicle/card/list.htm?tab=${row['vehicleState'] === "ALARM" ? 1 : 0}&unitId=${row.id}`, true);
                /*if (row.objectTypeId == 31) {
                    urlPath = Ptx.url('/mhouse/card.htm?unitId=' + row.id, true);
                }*/
                if (row.incidentText !== undefined) {
                    title = (row.incidentText).stripHTMLTags();
                }
                html += `<div class="block cursor-pointer" onclick="Ptx.fn.initModal('${urlPath}')" title="${title}">${vehicleIcon}</div>`;
            } else {
                html += vehicleIcon;
            }

            return html;
        }
    },

    'odometer': {
        'width': '60px',
        'className': 'text-center w60',
        'render': function (data, type, row) {
            if (row.odometer !== undefined) {
                var odoSortableSliced = 0;
                if (Math.sign(row.odometer) > 0) {
                    // Sort by whole number only.
                    const odoSortable = (row.odometer + '').replace(/[^\d.,]/g, '').split(/[.,]/)[0];
                    odoSortableSliced = ('0000000000' + odoSortable).slice(-10);
                }
                return `<div data-sort="${odoSortableSliced}">` + Number(row.odometer).toLocaleString(Ptx.lang) + `</div>`;
            } else {
                return '';
            }
        }
    },

    'incident_type': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return (row.incidentText !== undefined) ? row.incidentText : "";
        }
    },

    'mobile': {
        'className': 'visible-xs overflow-x',
        'render': function (data, type, row) {
            var address;
            var time;
            var battery = Ptx.tables.summary.getBattery(row.trackerBatteryState, 'pull-right top-5 m-left-10');
            var html = battery+'<span><strong>' + row.name + '</strong>';

            if (typeof row.registrationPlate !== 'undefined') {
                html += '<small>(' + row.registrationPlate + ')</small>';
            }
            html += '<br>';
            if (typeof row.lastPositionFullAddress !== 'undefined') {
                address = row.lastPositionFullAddress.replace('$', ' ');
                html += address;
            } else {
                if (Ptx.fn.isMobile()){
                    html += Ptx.html.resolvAddressBox('span', 'trackPoint', '', row.lastTpId, row.lastTpLat, row.lastTpLon, '', row.id, '');
                }
            }
            if (typeof row.lastPositionTime !== 'undefined') {
                time = row.lastPositionTime.replace('|', ', ');
                html += ' / ' + time;
            }
            return html;
        }
    },

    'tracker_battery_state': {
        'width': '55px',
        'className': 'hidden-xs text-center w55',
        'render': function (data, type, row) {
        	return Ptx.tables.summary.getBattery(row.trackerBatteryState, '');
        }
    },
	
	'manufacturing_info': {
		'width': '60px',
		'className': 'text-center hidden-xs w60 not-print not-search not-sorting',
		'render': function (data, type, row) {
			var batteryHtml;
			if (row.batteryStateRegardlessBatteryFlag != null) {
				batteryHtml = 'b-' + row.batteryStateRegardlessBatteryFlag + '%';
			} else {
				batteryHtml = 'XX';
			}
		
			var humidityHtml;
			if (row.humidity != null) {
				humidityHtml = 'h-' + Math.floor(row.humidity) + '%';
			} else {
				humidityHtml = 'XX';
			}
			
			var html = '<div>'
			var unitReportUrl = Ptx.url(`/reseller/manufacturingInfo/manufacturingQuickUnitReport.htm?unitId=${ row.id }`, true);
			var popupUnitReport = Ptx.getMsg('menu.reseller.report');
			html += `<div class="block cursor-pointer" onclick="Ptx.fn.initModal('${ unitReportUrl }', 'modal-full')" title="${ popupUnitReport }">${ batteryHtml }</div>`;
			
			var analogValuesUrl = Ptx.url(`/vehicle/statistics/listAnalogValues.htm?unitId=${ row.id }`, true);
			var popupAnalogValues = Ptx.getMsg('statistics.analogVals');
			html += `<div class="block cursor-pointer" onclick="Ptx.fn.initModal('${ analogValuesUrl }', 'modal-medium')" title="${ popupAnalogValues }">${ humidityHtml }</div>`;
			html += '</div>'
			return html;
		}
	},

    'map_shortcut': {
        'width': '30px',
        'className': 'text-center w30 not-print',
        'render': function (data, type, row) {
            if ((row.authorities['ROLE_USER_POSITION'] && row.positionType != null) && row.canSeePrivateData) {
                if (!row.inPrivateTrip || row.canSeePrivateData) {
                    let icoName = "fa-map-marker-alt";
                    let icoStyle = "solid";
                    let iconTitle = null;

                    if (row.positionType === "BTS") {
                        icoName = "icon-antenna font-26"
                        icoStyle = ""
                        iconTitle = Ptx.getMsg('icon.bts.info')
                    }
                    else if (row.positionType === "MANUAL") {
                        icoName = "icon-antenna font-26"
                        icoStyle = ""
                    }

                    return Ptx.html.btn({href: Ptx.url('/map/map.htm?unitId=' + row.id, true), className: 'ptx-page-open text-primary font-huge-i d-block', icon: icoName, faStyle: icoStyle, iconTitle: iconTitle, moreLinkAttributes: 'style="margin-right: 5px;"'});
                }
            }
            if (row.viewPositionType == 'LAST_TP')
                return Ptx.html.icon({icon: "fa-window-close", cssClass: "text-primary font-huge-i", title: Ptx.getMsg('icon.lastTp.info'), faStyle: "regular"})
            return "-";
        }
    },

    'name': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return `<strong>${row.name}</strong>`;
        }
    },

	'registration_plate': {
		'className': 'hidden-xs',
		'render': function (data, type, row) {
			/* Data that is only being used for search, but not for the DOM itself */
			var searchData = '';
			if (row.identifiers) searchData += row.identifiers + ' ';
			if (row.MSISDN) searchData += row.MSISDN + ' ';
			if (row.ICCID) searchData += row.ICCID;

			/* The data used for 'filter' is used for searching, but is not present in the DOM.
			It can only be accessed via Local Storage, which is created by Datatables.
			The data used for 'display' is what is in the DOM, and 'sort' is used for sorting using the data provided. */
			if (type === 'display' || type === 'sort') {
				return row.registrationPlate || '';
			}

			if (type === 'filter') {
				return searchData.toLowerCase();
			}

			return '';
		}
	},

    'last_position': {
        'width': '240px',
        'className': 'overflow-x hidden-xs',
        'render': function (data, type, row) {
            var html = '';

            if (row.positionType == 'BTS')
                html += '<div class="col-sm-2 text-center" style="padding-top:8px" >' + Ptx.html.icon({ icon: 'fa-circle-dot', cssClass: 'text-primary' +
							' font-huge-i', title: Ptx.getMsg('icon.bts.info') }) + '</div>';
            if (row.lastPositionTime !== undefined) {
                html += '<span class="hidden">' + row.lastPositionTimeStamp + '</span><small>' + row.lastPositionTime.replace('|', ', ') + ' (' + row.lastCommunicationTimeDiff + ')</small><br/>';
            }
            if (row.lastPositionFullAddress !== undefined) {
                html += row.lastPositionFullAddress.replace('$', ' ');
            } else {
                if (Ptx.fn.isDesktop()) {
                    html += Ptx.html.resolvAddressBox('span', 'trackPoint', '', row.lastTpId, row.lastTpLat, row.lastTpLon, (row.clientId !== undefined ? row.clientId : ''), row.id, '');
                }
            }
            return html;
        }
    },

 	'geozones': {
        'className': 'overflow-x hidden-xs',
        'render': function (data, type, row) {
            var html = ''; 
            if (row.canSeePrivateData) {
                if (row.lastPositionGeozones !== undefined) {
                    html += row.lastPositionGeozones.replace('$', ' '); 
                } 
            } else {
                if (row.iOnStatus > 0) {
                    html += Ptx.html.icon({icon: 'fa-circle-notch', cssClass: 'fa-spin fa-lg'}) + ' ' + Ptx.getMsg('common.onGoingTrip');
                } else {
                    html += Ptx.getMsg('summary.vehicle.inPrivate');
                }
			}

			if (html == '') {
                return '<span class="hidden">Z</span>';
            } //sort empty to the end
            return html;
        }
    },


    'last_communication': {
        'className': 'text-right hidden-xs not-search',
        'render': function (data, type, row) {
            return (row.lastCommunicationTime !== undefined) ? `<span class="hidden">${row.lastCommunicationTimeStamp}</span>` + row.lastCommunicationTime.replace('|', '<br />') : '';
        }
    },

    'maintenance': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return (row.maintenance !== undefined) ? Ptx.tables.summary.maintenance(row.id, row.maintenance, row.maintenanceAlarm) : '';
        }
    },

    'summary_maintenance': {
        'className': 'hidden-xs',
        'render': function (data, type, row) {
            return (row.summaryMaintenance !== undefined) ? Ptx.tables.summary.maintenance(row.id, row.summaryMaintenance, row.summaryMaintenanceAlarm) : "";
        }
    },

    'communication_warning': {
        'width': '50px',
        'className': 'hidden-xs w50 text-center',
        'render': function (data, type, row) {
            var html = '', order;
            if (row.highHumidity) {
                html += '<div class="inline-block" data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('javascript.summary.highHumidity') + '">'+Ptx.html.icon({icon: 'fa-tint', cssClass: 'text-primary', cssStyle: 'font-size: 150%'})+'</div>';
            }

            if (row.lastCommunicationState !== undefined) {
                var note, img;
                if (row.lastCommunicationState === 'A') {
                    note = "javascript.summary.noCommunicationMoreThanOneMonth";
                    img = "danger";
                    order = 2;
                } else if (row.lastCommunicationState === 'W') {
                    note = "javascript.summary.noCommunicationMoreThanThreeDays";
                    img = "warning";
                    order = 1;
                }
                return '<span class="hidden">' + order + '</span><div class="inline-block" data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg(note) + '">'+Ptx.html.icon({icon: 'fa-exclamation-triangle', cssClass: 'resolve text-' + img, cssStyle: 'font-size:125%'})+'</div>'+html;
            } else {
                order = 0;
                return '<span class="hidden">' + order + '</span>  '+ html;
            }
        }
    },

    'driver': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            return (row.driverName !== undefined) ? row.driverName : "";
        }
    },

    'reseller_name': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            return row.resellerName
        }
    },

    'customer_name': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            return row.customerName;
        }
    },

    'password_for_communication': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            return (row.passwordForCommunication !== undefined) ? row.passwordForCommunication : "";
        }
    },

    'security_agency_alarm_sound_toggle': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            let cssClassPostfix = row.playAlarmSoundAllowed ? "off" : "up";

            return `<a id="soundBtn${row.id}" href="javascript:Ptx.page.ctx.toggleSound(${row.id})">`+Ptx.html.icon({icon: 'fa-volume-'+cssClassPostfix})+`</a>`;
        }
    },

    'map_type': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, row) {
            return row.mapTypeName;
        }
    },

    'hugo_balance': {
        'className': 'text-center hidden-xs',
        'render': function (data, type, unit) {
            var html = '', imgSrc = '';

            if (unit.hugoBalance != null) {
                if (unit.hugoBalance == -2) {
                    imgSrc = 'unknown';
                } else if (unit.hugoBalance == -1) {
                    imgSrc = 'outside';
                } else if (unit.hugoBalance == 0) {
                    imgSrc = 'normal';
                } else if (unit.hugoBalance == 1) {
                    imgSrc = 'low';
                } else if (unit.hugoBalance == 2) {
                    imgSrc = 'empty';
                }
                if (imgSrc != '') {
                    html += '<a href="https://www.hu-go.hu/" target="_blank"><img src="' + Ptx.url('/img/u/ico/hugo_' + imgSrc + '.png') + '" alt="' + imgSrc + '"/></a>';
                }
            }
            return html;
        }
    },

	'analog_values': {
		'width': '280px',
		'className': 'hidden-xs text-left',
		'render': function (data, type, row) {
			// row is SummaryResult

			var summary = "", // AV directly into table cell
					count = 0,
					tooltip = "", // AV is not inside cell, but it is shown inside popover
					avCount = 0,
					iconAdded = false; // Flag variable to track if the icon has been added

			row.analogValues.map(function (val) {
				// val is AnalogValueSummary

				if (val.value !== null && val.value !== undefined) {
					let valueWithUnit = val.value + ' ' + val.unit;

					var communicationTimeStamp = row.lastCommunicationTimeStamp;
					var analogValueTimeStamp = Date.parse(val.time);
					var timeFormatted = moment(analogValueTimeStamp).format('YYYY-MM-DD HH:mm');

					var differenceInMilliseconds = communicationTimeStamp - analogValueTimeStamp;
					var differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

					if (!iconAdded && differenceInHours > 2) {
						summary += '<i class=\'fa-solid fa-circle-exclamation text-bright-gray text-center margin-auto block font-14\'></i>';
					}

					if (count < val.show) {
						summary += '<div><div class=\'col-sm-8 text-left no-padding overflow-x\'>' + val.name + ':</div><div class=\'col-sm-4 text-left' +
								' no-padding overflow-x\'>';
						summary += valueWithUnit;
						summary += '</div></div>';
					}

					tooltip += '<div class=\'text-left\' style=\'overflow-wrap:break-word;\'>';

					if (!iconAdded && differenceInHours > 2) {
						tooltip += '<i class=\'fa-solid fa-circle-exclamation text-bright-gray \'></i> ' +
								Ptx.getMsg('common.data.notCurrent') + '<br>';
						iconAdded = true; // Set the flag to true to indicate the icon has been added
					}

					tooltip += val.name + ': ' + valueWithUnit + '</div><div' +
							' class=\'text-left\'>';

					tooltip += '<span class=\'font-smallest text-gray block\'>' + timeFormatted + '</span><br>';
					tooltip += '</div>';

					avCount++;
					count++;
				}
			});
			if (tooltip !== "")
				tooltip = 'data-bs-toggle="popover" data-placement="auto" data-html="true" data-content="<div>' + tooltip + '</div>"';
			var html = '<div class="clearfix" style="display:flex" ' + tooltip + '>';
			html += '<div style="float:left;flex-grow: 32">' + summary + "</div>";
			if (avCount > 0 && row.authorities['ROLE_USER_STATISTICS']) {
				html += '<div style="display:flex; align-items:center">' +
						Ptx.html.btn({
							href: Ptx.url('/statistics/charts/list.htm?analogPreselectFavouriteAV=true&filterUnitId=' + row.id + "&type=5", true),
							className: 'btn ptx-page-open btn-edit',
							icon: 'fa-chart-bar',
							iconTitle: Ptx.getMsg('statistics.analogVals')
						})
						+ "</div>"
			}
			html += '</div>';
			return html;
		}
	},

	'external_link' : {
    	'width': '50px',
        'className': 'text-center w50 hidden-xs',
        'render': function (data, type, row) {
        	return (row.externalLink == null || row.externalLink == undefined) ? "" : `<a href="${row.externalLink}" target="_blank">`+Ptx.html.icon({icon: "fa-external-link"})+`</a>`;
        }
    },

    'logbook_shortcut': {
        'width': '45px',
        'className': 'text-center hidden-xxs w45 not-print not-search',
        'render': function (data, type, row) {
            return (row.authorities['ROLE_USER_LOGBOOK']) ? Ptx.html.btn({href: Ptx.url('/history/logbook.htm?filterUnitId=' + row.id, true), className: 'btn ptx-page-open btn-edit', icon: 'fa-book'}) : "";
        }
    },

    'buttons': {
        'width': '45px',
        'className': 'text-center w45 not-print not-search',
        'render': function (data, type, row) {
            var problems = 0, htmlPrimary = '', htmlSecondary = '';

            if (row.authorities['ROLE_USER_LOGBOOK']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/history/logbook.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-book fa-fw', content: Ptx.getMsg('menu.logbook')}) + '</li>';
            }
            if (row.authorities['ROLE_USER_TACHOGRAPH_CORRECTION']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/service/correctionOfOdometer/list.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-tachometer-alt fa-fw', content: Ptx.getMsg('menu.service.correctionOfOdometer')}) + '</li>';
            }
            if (row.authorities['ROLE_USER_FUELLING']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/service/fuelling/fuelling/list.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-tint fa-fw', content: Ptx.getMsg('menu.service.fuelling')}) + '</li>';
            }
            if (row.authorities['ROLE_USER_GEOZONES'] && row['positionType'] != null) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/settings/geozones/geozones/insert.htm?unitId=' + row.id, true),
                    className: 'ptx-show-modal', icon: 'fa-circle fa-fw', content: Ptx.getMsg('menu.unit.geozone'),
                    moreLinkAttributes: 'data-ptx-modal-size="modal-full"'}) + '</li>';
            }
            if (row.authorities['ROLE_RESELLER'] || row.authorities['ROLE_ADMIN']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/settings/report/list.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-list fa-fw', content: Ptx.getMsg('menu.reseller.report')}) + '</li>';
            }
            if (row.authorities['ROLE_ADMIN']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/reseller/unitConfiguration/unitConfiguration/wizard.htm?unitId=' + row.id, true),
                    className: 'ptx-show-modal', icon: 'fa-wrench fa-fw', content: Ptx.getMsg('menu.reseller.unitConfiguration'),
                    moreLinkAttributes: 'data-ptx-modal-size="modal-full"'}) + '</li>';
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/reseller/communication/gate/list.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-paper-plane fa-fw', content: Ptx.getMsg('common.smsGate')}) + '</li>';
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/statistics/charts/list.htm?filterUnitId=' + row.id, true),
                    className: 'ptx-page-open', icon: 'fa-chart-bar fa-fw', content: Ptx.getMsg('statistics.title')}) + '</li>';
            }
            if (row.authorities['ROLE_SECURITY_AGENCY']) {
                htmlPrimary += '<li>' + Ptx.html.btn({
                    href: Ptx.url('/securityAgency/configurationOfUnit/notePopup.htm?unitId=' + row.id, true),
                    className: 'ptx-show-modal', icon: 'fa-pencil fa-fw', content: Ptx.getMsg('common.noteOfSecurityAgency')}) + '</li>';
            }

            htmlPrimary += Ptx.html.smsCommands(row.id, row['smsTemplates'], !(!!row['MSISDN'])); //is MSISDN null/undefined/empty

            if (row['incidentText'] !== undefined) {
                problems++;
                htmlSecondary += '<li><a href="#">'+Ptx.html.icon({icon: 'fa-exclamation', cssClass: 'fa-fw'})+row['incidentText'] + '</a></li>';
            }
            if (row['lastCommunicationState'] !== undefined) {
                problems++;
                var note, img;
                if (row['lastCommunicationState'] === 'A') {
                    note = "javascript.summary.noCommunicationMoreThanOneMonth";
                    img = "danger";
                } else if (row['lastCommunicationState'] === 'W') {
                    note = "javascript.summary.noCommunicationMoreThanThreeDays";
                    img = "warning";
                }
                htmlSecondary += '<li><a class="overflow-x ptx-show-modal" style="max-width:200px;" href="'+Ptx.url('/vehicle/card/list.htm?tab=1&unitId=' + row.id)+'">'
                    + Ptx.html.icon({icon: 'fa-exclamation-triangle', cssClass: 'fa-fw'})+'<span class="resolve text-' + img + '" data-key="' + note + '"></span></a></li>';
            }
            if (htmlPrimary.length > 0 && htmlSecondary.length > 0) {
                htmlPrimary += '<li role="separator" class="divider"></li>';
            }
            htmlPrimary += htmlSecondary;

            if (htmlPrimary.length > 0) {
                return '<div class="dropdown"><a id="" type="button" class="btn ptx-show-dropmenu btn-menu" href="#" data-bs-toggle="dropdown">'
                    + Ptx.html.icon({icon: 'fa-caret-down'})+(problems > 0 ? '<span class="label label-danger' +
                    ' label-notify' +
                    ' visible-xs">' + problems + '</span>' : '') + '</a>'
                    + '<ul class="dropdown-menu dropdown-menu-right text-left" role="menu" aria-labelledby="dLabel">' + htmlPrimary + '</ul></div>';
            }

            return htmlPrimary;
        }
    },

}

/**
 * return draw of tracker battery
 * @alias Ptx.tables.summary.getBattery
 * @see BatteryTag in java as well
 * @param battery
 * @param classes
 * @returns {string}
 */
export function getBattery(battery, classes) {
	if (battery !== undefined) {
		const COLOR_GREEN = '#22b348';
		const COLOR_ORANGE = '#fca103';
		const COLOR_RED = '#e32739';

		const color = battery > 59 ? COLOR_GREEN : (battery > 19 ? COLOR_ORANGE : COLOR_RED);
		const bgHeight = Math.max(10, battery);
		const batteryStatSliced = ('000' + battery).slice(-3);

		return `<div class="btn-battery ${classes}" data-sort="${batteryStatSliced}" title="${battery}%" data-bs-toggle="tooltip" data-placement="bottom">
        <div class="btn-battery-charge-level" style="height: ${bgHeight}%; background: ${color};"></div>
        </div>`;
	} else {
		return '';
	}
}

/**
 * Vykresleni udrzeb (bezne i summary)
 * @alias Ptx.tables.summary.maintenance
 * @param unitId
 * @param maintenanceValue
 * @param alarmValue
 * @returns {string}
 */
export function maintenance(unitId, maintenanceValue, alarmValue) {
    var resultHtml = '';
    if (maintenanceValue == null) return resultHtml;

    var maintenanceRegex = /((?:regular)|(?:periodic))((?:Alert)|(?:Info))(Link)?( .+)?/g;
    var rArr = maintenanceRegex.exec(maintenanceValue);
    if (rArr == null) {
        // vypsani textove - zbyvajiciho casu
        resultHtml = maintenanceValue.replace(/,/g, '<br>');
    } else {
        // vytvoreni titulku z alarmovych udrzeb
        var alarmList = eval(alarmValue);
        var title = '';
        if (alarmList) {
            for (var i = 0; i < alarmList.length; i++) {
                var al = alarmList[i];
                if (al.type) title += Ptx.getMsg('common.type') + ': ' + al.type
                if (al.note) {
                    if (al.type) title += ', ';
                    title += Ptx.getMsg('common.note') + ': ' + al.note;
                }
                if (al.type || al.note) title += '<br>';
            }
        }
        if (title.length > 0) {
        	title = title.replace(/\\([\s\S])|(")/g,"\\$1$2");
        	title = ' data-bs-toggle="popover" data-html="true" data-placement="bottom" data=html="true" data-content="' + title + '"';
        }

        // detekce ikony a odkazu podle poslaneho stavu
        var info = rArr[2] == 'Info';
        var alert = rArr[2] == 'Alert';
        var regular = rArr[1] == 'regular';
        var periodic = rArr[1] == 'periodic';
        var link = rArr[3] == 'Link';

        // ikona info/warn
        var img = '';
        if (info) img = '<div class="btn-maintenance"><i class="fa-solid fa-gear"></i></div>';
        else if (alert) img = '<div class="btn-maintenance btn-maintenance-alert"><i class="fa-solid fa-gear"></i></div>';

        // odkaz periodic/regular
        if (link) {
            if (regular) resultHtml = '<a class="ptx-page-open" href="' + getUrl('/service/maintenance/regular/list.htm?filterUnitId=' + unitId, true) + '"' + title + '>' + img + '</a>';
            else if (periodic) resultHtml = '<a class="ptx-page-open" href="' + getUrl('/service/maintenance/periodic/list.htm?filterUnitId=' + unitId, true) + '"' + title + '>' + img + '</a>';
        } else {
            resultHtml = '<span '+title+'>' + img + '</span>';
        }
    }
    return resultHtml;
}

/**
 * Initialize data table by summary data json
 * @alias Ptx.tables.summary.init
 * @param data
 * @param groupId
 * @param ctx
 */
export function initSummary( data, groupId, ctx ) {
    /* setting column */
    Ptx.tables.summary.col = [];
    Ptx.tables.summary.order = Ptx.tables.summary.order || [];

    var includedCols = [];
    var i = 0;
    var e = 0;
    var defaultState = '';
    var unitIgnition = $('#unitIgnition');
    var summaryTableTemplate = $('#summary-table-template', ctx);
    var $showHideCol = $('#showHideColumns');

    if (unitIgnition.val()) {
        defaultState = unitIgnition.val() === "all" ? "" : unitIgnition.val();
    }

    // default order for main table in mobile view
	isMobile(function() {
		summaryTableTemplate.find('th[data-deforder]').removeAttr('data-deforder');
		summaryTableTemplate.find('th[data-identificator="7"]').attr('data-deforder','asc');
	});

    /* find settings by main table column */
    Ptx.tables.summary.searchCol.length = 0;
    summaryTableTemplate.find('thead th').each(function () {
        var colset = Ptx.tables.summary.colSettings[ $(this).data('name') ];

        if ($(this).data('deforder') && Ptx.tables.summary.order.length < 1) {
            Ptx.tables.summary.order.push([i, $(this).data('deforder')]);
        }

        var headset = {
            "data": $(this).data('name'),
            "orderable": $(this).data('sortable'),
            "visible": $(this).data('visible'),
        };

        // need for default state filter
        if ($(this).data('name') == 'move_state') {
            unitIgnition.attr('data-column-id', i);
            $(".counterStat").attr('data-column-id', i);
            Ptx.tables.summary.searchCol.push({"search": defaultState});
        } else {
            Ptx.tables.summary.searchCol.push(null);
        }

        Ptx.tables.summary.col.push( $.extend(colset, headset) );

        if (! $(this).data('exclude') == true) includedCols.push(i);
        i++;
    });

    var clonedSummaryTable = summaryTableTemplate.clone().attr('id', 'summary-table-cloned-temporary');
    //mainTable.insertBefore(summaryTableTemplate).hide(); this would duplicate summary-table-main inside DOM on each 30s refresh.

    Ptx.tables.summary.mainTable = clonedSummaryTable.DataTable({
        "dom" : "t",
        "stateSave" : true,
        "stateSaveCallback" : function(oSettings, oData) {
            localStorage.setItem('SummaryMainTable', JSON.stringify(oData));
        },
        "stateLoadCallback" : function(oSettings) {
            return JSON.parse(localStorage.getItem('SummaryMainTable'));
        },
    });

    drawSummary(data, groupId, ctx);
	Ptx.fn.initComponents(ctx);

    initGroupFilter();

    // Create ColVis on the first table only
    var colvisBtn = new $.fn.dataTable.Buttons(Ptx.tables.summary.mainTable.table(0), {
        buttons: [ {
            extend: 'colvis',
            columns: includedCols,
            text: summaryTableTemplate.data('colvis-button'),
            columnText: function ( dt, idx, title ) {
                return summaryTableTemplate.find("th").eq(idx).html();
            },
        } ]
    });

    $showHideCol.html('');
    $showHideCol.prepend( colvisBtn.container() );

    $showHideCol.find('.buttons-colvis').on('click', function () {
        delay(100, function () {
            var $menu = $('.dt-button-collection .dropdown-menu');

            if ( $menu.length ) {
                if ( ! $(".dt-button-default").length ) {
                    $menu.append('<li class="dt-button dt-button-default"><a class="ptx-call-action" href="' + getUrl('/summary/setDefault.json') + '">Default</a></li>');
                }

                // remove all data from local storage for success default and remove saved data settings from DB
                $('.dt-button-default').on('click', function () {
                    localStorage.clear();
                    openWithParams(getUrl('/summary/setDefault.json'), 'POST', null, null);
                    location.reload();
                })
                actionCall($menu);
            }
        });
    });
}

/**
 *  build tables by the main table and draw
 *  @alias Ptx.tables.summary.draw
 *  @param data
 *  @param groupId
 *  @param ctx
 */
export function drawSummary(data, groupId, ctx) {
    $('.counterStat', ctx).off(); // multiple event trigger

    Ptx.tables.summary.groupId = groupId;
    var groupBy = Ptx.tables.groupOptions[groupId];

	$("#groupingListContainer").on("click", "[id^='groupingList-']", function() {
		$("[id^='groupingList-']", ctx).removeClass("active");
		$(this).addClass("active");
		Ptx.tables.summary.groupFilter = "";
	});

    /* destroy datatable instances*/
    var oldClonedSummaryTables = $('.initDataTable', ctx);
    oldClonedSummaryTables.DataTable().destroy(true); // destroys and removes all (even grouped) datatables from DOM

    if (data == null) {
        data = Ptx.tables.summary.data;
    }

    /* Sorting data by user group name (duplicate vehicle which have more group) */
    var groupNameData = [];
    if (groupId == 3) {
        data.forEach(function (e) {
            var i = 0;
            for (var key in e['userGroupName']) {
                var x = Object.create(e);
                x['userGroupName'] = e['userGroupName'][key];
                x['userGroupId'] = key;
                groupNameData.push(x);
                i++;
            }
            if (i == 0) {
                e['userGroupName'] = null;
                groupNameData.push(e);
            }
        });
        groupNameData;
    } else {
        $.extend(groupNameData, data);
    }

    /* Add group to data object*/
    var groupData = {};
    groupNameData.forEach(function (e) {
        var arr;

        if (e[groupBy] === undefined) {
            arr = 'none';
        } else {
            arr = e[groupBy];
        }

        if (groupData[arr] === undefined) {
            groupData[arr] = [];
        }
        groupData[arr].push(e);
    });

    var summaryTableTemplate = $('#summary-table-template');

    for (var key in groupData) {
        var newClonedSummaryTable = summaryTableTemplate.clone().addClass('initDataTable');
        var id = 'summary-table-cloned-grouped-actual-datatable';
	
		var x = Math.round(Math.random() * 100000);
        newClonedSummaryTable.attr('id', id + '-' + key + '-random-number-' + x).show();
        newClonedSummaryTable.insertAfter(summaryTableTemplate);

        // for rendering grouping header
		if (key != null && key !== 'null' && key !== 'none') {
			let html = `<caption><a href="#" class="no-decoration do-captionSlide">`;
			let groupFilter = '';

			const groupItem = groupData[key][0];

			groupId = parseInt(groupId);
			switch (groupId) {
				case 1:
					html += `<i class="icon-${groupItem.baseIcoName} plane font-28"></i> ${groupItem.icoNameI18n}`;
					groupFilter = groupItem.objectTypeId;
					break;
				case 2:
					html += `<div class="pull-left" style="width:3px; height: 20px; margin-right: 10px; background-color: #${groupItem.color}"></div>`;
					groupFilter = groupItem.color;
					break;
				case 3:
					html += groupItem.userGroupName;
					groupFilter = groupItem.userGroupId;
					break;
				case 4:
					html += groupItem.orderDestination;
					groupFilter = groupItem.orderDestinationId;
					break;
			}

			const groupingUrl = getUrl(`/map/map.htm?groupingId=${groupId}&amp;groupFilter=${groupFilter}`, true);
			const globeBtn = btn({ href: groupingUrl, className: 'btn ptx-page-open pull-right right-20 font-bigger-i', ico: 'fa-globe' });
			html += ` (${groupData[key].length})</a>${globeBtn}</caption>`;

			newClonedSummaryTable.attr('data-group', groupFilter);
			newClonedSummaryTable.prepend(html);
		}

        // sorting fort summary datatable
        onSort(newClonedSummaryTable, function (name, order) {
            openWithParams(getUrl('/summary/toggleSort.htm'), 'POST', {col: name, order: order, sm_dec:'none'}, null);
        });

        var summarySettings = {
            "data": groupData[key],
            "deferRender": true,
            "dom": "t",
            "search": {
                search: Ptx.tables.defaultSearch
            },
            "searchCols": Ptx.tables.summary.searchCol,
            "order": Ptx.tables.summary.order,
            "autoWidth": false,
            "pageLength": 50,
            "processing": true,
            "responsive": {
                details: false
            },
            "columnDefs": [{
                type: 'value-for-sort',
                targets: '_all' // Apply diacritic sorting to all columns
            }, {
                type: 'natural',
                targets: 'sorting-natural'
            }, {
                searchable: false,
                targets: 'not-search'
            }],
            "columns": Ptx.tables.summary.col,
            "fixedHeader": {
                "header": groupData[key].length >= 5,
                "footer": false,
                "headerOffset": 50,
            },
            "initComplete": function(settings, json) {
                setTimeout(function() {
                    var e = jQuery.Event('keyup', {
                        which: 13,
                        keyCode: 13
                    });
                    $('#searched').trigger(e);

                    var table = $.fn.dataTable.tables({
                        visible: true,
                        api: true
                    });
                    table.page.len(-1).draw();
                }, 250);
            },
            "drawCallback": function(settings) {
                clearTimeout(Ptx.tables.drawCallbackDelay);
                Ptx.tables.drawCallbackDelay = delay(500, function() {
                    bulkResolve('trackPoint', ctx);
                    msgResolve(ctx);
                })
            }
        }
        statusCounter(data);
        newClonedSummaryTable.DataTable(summarySettings);
    }

    fillGroupFilter(groupData, Ptx.tables.summary.groupId);

    var clonedSummaryTables = $('.initDataTable', ctx);
    calculateAverageColumnWidth(clonedSummaryTables);

    var dtTables = clonedSummaryTables.DataTable();

    // save table column order when click on table header column
	$( ".initDataTable" ).on( "order.dt" , function () {
		const tableOpts = getSession( "SummaryMainTable" );
		setSession( "SummaryMainTable", { ...tableOpts, order: Ptx.tables.summary.order } );
	} );

    // Init search on keyup
    $('#searched').on('keyup', function () {
        dtTables.search(this.value).draw();
    });

    initChangeUnitIgnition(ctx, dtTables);

    if (Ptx.tables.summary.firstLoad == 1) {
        $('#unitIgnition').trigger("change");
        $('#searched').keyup();
        Ptx.tables.summary.firstLoad = 0;
    }

    // Set of column visible after redraw
    var columns = Ptx.tables.summary.mainTable.table(0).columns().visible();
    $('.initDataTable', ctx).each(function () {
		var initDt = $(this).DataTable();
        for (var i = 0; i < columns.length; i++) {
			initDt.columns(i).visible(columns[i]);
        }
    });

    // When the column visibility changes on the first table, also change it on the others
    Ptx.tables.summary.mainTable.table(0).on('column-visibility', function (e, settings, colIdx, visibility) {
        clonedSummaryTables.each(function () {
            $(this).DataTable().column(colIdx).visible(visibility);
        });
        var headerNode = Ptx.tables.summary.mainTable.table(0).column(colIdx).header(); // podle id sloupce z datatables najdu header cell
        var settingId = $(headerNode).data('identificator'); // v header cell mám uloženo Page.Setting id v data-identificator

        calculateAverageColumnWidth(clonedSummaryTables);

        openWithParams(getUrl('/summary/toggleCol.htm'), 'POST', {settingId: settingId, sm_dec:'none'}, null, {showLoader: false});
        $('#summary-table-template th[data-identificator="'+settingId+'"]').attr('data-visible', visibility)
        msgResolve('#content');
    });
    initSummaryComponents('#content');

    // need for refresh page to catch scrollbar still down
    delay(1500, function() {
        updateMinHeight()
    });
    let scrollTo = sessionStorage.getItem('contentScrollTop');
    window.scrollTo(0, parseInt(scrollTo));

    // this code is executed every "ajax" refresh, not only once on page reload.
    var time = Ptx.tables.summary.refreshTimeInSeconds * 1000; // time between AJAX reloads (light refreshes), in [ms]

    // auto refresh
	refresh(time, function () {
		openWithParams(Ptx.tables.summary.url, 'GET', {sm_dec:'none'}, function (data) {
			Ptx.tables.summary.data = data;
			initSummary(data, Ptx.tables.summary.groupId, ctx);
		}, {showLoader: false});
	});
}

/**
 * @alias Ptx.tables.summary.statusCounter
 * @param data
 */
export function statusCounter(data) {
    var counter = {
        "alarm": 0,
        "warning": 0,
        "inMotion": 0,
        "ready": 0,
        "motionless": 0,
        "battery": 0
    };

	data.map(function(row){
        if (row.vehicleState == 'ALARM') {
            counter['alarm']++;
        }

        if (row.iOnStatus >= 0) {
            counter['inMotion']++;
		} else if (row.iOnStatus == -1){
            counter['ready']++;
		} else{
            counter['motionless']++;
        }

        if (row.trackerBatteryState < 19) {
            counter['battery']++;
        }
        if (row.lastCommunicationState !== undefined && (row.lastCommunicationState === 'A' || row.lastCommunicationState === 'W')) {
            counter['warning']++;
        }
    });
	$("#counterInMotion").text(counter['inMotion']);
	$("#counterReady").text(counter['ready']);
	$("#counterMotionless").text(counter['motionless']);
	$("#counterBattery").text(counter['battery']);
	$("#counterWarning").text(counter['warning']);
	$("#counterAlarm").text(counter['alarm']);
	$("#counterAllUnits").text(data.length);
}

/**
 *  status in tables(summary, map), ongoing etc
 *  @alias Ptx.tables.renderStatus
 */
export function renderStatus(row) {
	var state, html = '', order = '', search = [];

	if (row.vehicleState == 'ALARM' || row.vehicleState == 4) {
		search.push('inalarm');
	}

	if (row.iOnStatus > 0) {
		search.push('onthemove');
		state = 'success.svg';
		order = '3';
	} else if (row.iOnStatus === -1) {
		search.push('ready');
		state = 'ready.svg';
		order = '2';
	} else if (row.iOnStatus === 0 && row.unitUsageId !== 2) {
		search.push('onthemove');
		order = '1';
		state = row.speed > 0 ? 'success.svg' : 'ignOn.svg';
	} else if (row.unitUsageId === 2) {
		order = '1';
		search.push('motionless');
		state = 'sensor.svg';
	} else {
		search.push('motionless');
		state = 'ignOff.svg';
		order = '1';
	}

	const hiddenSpan = `<span class="hidden">${order}${row.iOnStatus}</span>`;
	html = hiddenSpan;
	if (row.iOnStatus >= 0 || row.unitUsageId === 2) {
		const speedometerImg = `<img src="${getUrl(`/img/speedometer-${state}`)}"/>`;
		html += speedometerImg;

		if (row.iOnStatus < 999 && row.speed && row.unitUsageId !== 2) {
			const speedHtml = `
      <br/>
      <span class="font-smallest-i">
        ${row.speed}&nbsp;<span class="resolve" id="box_speed${e}" data-key="common.shortcut.kmAHour">km/h</span>
      </span>`;
			html += speedHtml;
		}
	} else {
		const rotatedSpeedometerImg = `<img class="rotate-195" src="${getUrl(`/img/speedometer-${state}`)}"/>`;
		html += rotatedSpeedometerImg;
	}

	if (row.trackerBatteryState < 19) {
        search.push('emptybattery');
    }

	if (row.lastCommunicationState !== undefined) {
	    if (row.lastCommunicationState === 'A' || row.lastCommunicationState === 'W') {
            search.push('withwarning');
        }
	}

	for (var i=0;i<search.length;i++){
	    html += '<span class="hidden">'+search[i]+'</span>';
	}

	return html;
}

export const mapColSettings = {
    'show': {
        'className': 'text-center w40',
        'render': function (data, type, row) {
            var check = "", chosenUnit = "";
            var unitId = Ptx.tables.map.unitId;

            // show units (depends on "mapVisibleUnits" key in localStorage) if no specific unit is chosen, otherwise disable all checkboxes
            if ( unitId == null ) {
                if ( Ptx.tables.map.notVisibleUnits.indexOf( row.id ) == -1 ) check = 'checked="checked"';
            } else {
                check = 'disabled="disabled"';
            }

            if ( Ptx.tables.map.htmlUnitId == row.id.toString() ) chosenUnit = " unit-chosen";

            return '<span><input name="unit-visible" id="unit-visible_' + row.id + '" ' + check + ' class="visible unit-visible' + chosenUnit + '" type="checkbox" data-unit-id="' + row.id + '"/></span>';
        }
    },

    'state': {
        'className': 'text-center w40',
        'render': function (data, type, row) {
            e++;
            return Ptx.tables.renderStatus(row);
        }
    },

    'vehicle': {
        'className': 'text-center w60',
        'render': function (data, type, row) {
            var css, urlPath, vehicleIcon = "", html = '';
            //TODO vozidla v privatni jizde se do tabulky s mapou vubec nedostanou
            if (row.vehicleState == '1') {
                css = 'text-business';
            }
            else if (row.vehicleState == '2') {
                css = 'text-private';
            }
            else if (row.vehicleState == '4') {
                css = 'text-alarm anim-flicker';
            }

            html += '<span class="hidden">' + row.icoName + '</span>';
            if (row.vehicleState == 'ALARM') {
                urlPath = Ptx.url('/vehicle/card/list.htm?tab=1&unitId=' + row.id, true);
            } else {
                urlPath = Ptx.url('/vehicle/card/list.htm?tab=0&unitId=' + row.id, true);
            }

            vehicleIcon += '<div style="display: inline-block; padding-left: 10px;">';
            vehicleIcon += '<div style="float:left; height:22px; margin-top: 3px; margin-right:7px; margin-left:-10px; border-left: 3px solid #' + row.color + ';"></div>';
            vehicleIcon += '<i class="icon-' + row.icoName + ' font-26 ' + css + '" data-bs-toggle="tooltip" data-placement="bottom"></i></div>';

            if (row.authorities['ROLE_USER_SUMMARY']) {
            	html += '<a class="ptx-show-modal" href="' + urlPath + '">' + vehicleIcon + '</a>';
            } else {
            	html += '<a href="#">'+vehicleIcon+'</a>';
            }

            return html;
        }
    },

	'name': {
		'className': 'overflow-x',
		'render': function (data, type, row) {
			var address, time;
			var html = '<span><strong>' + row.name + '</strong>';

			if (row.driver) {
				html += '<small> (' + row.driver + ')</small>';
			}

			if (type === 'filter') {
				var searchData = '';
				if (row.name) searchData += row.name + ' ';
				if (row.identifiers) searchData += row.identifiers + ' ';
				if (row.regPlate) searchData += row.regPlate + ' ';
				if (row.MSISDN) searchData += row.MSISDN + ' ';
				if (row.ICCID) searchData += row.ICCID + ' ';
				return searchData.toLowerCase();
			}

			if (type === 'display' || type === 'sort' || type === 'filter') {
				html += '<br>';

				if (row.address) {
					address = row.address.replace('$', ' ') + ' / ';
				} else {
					address = Ptx.html.resolvAddressBox('span', 'trackPoint', '', row.id, row.lat, row.lon, '', '', '');
				}

				if (row.time) {
					time = row.time.replace('|', ', ')
				}
				html += address + ' ' + time;
				return html;
			}

			return '';
		}
	},


    'button': {
        'className': 'text-center w40',
        'render': function (data, type, row) {
            var html = '';

            html += '<div class="btn-group">'
                + '<a href="#" class="btn btn-menu dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" style="padding: 1px 6px; min-height:' +
					' 20px;">'
                + '  <span class="fa-solid fa-caret-down"></span>'
                + '</a>'
                + '<ul class="dropdown-menu dropdown-menu-right" role="menu">';
                if (row.authorities['ROLE_USER_LINK_TO_POSITION']) {
                	html +=
                        '<li>' +
                            '<a class="ptx-show-modal" href="' + Ptx.url('/settings/linksToPosition/insert.htm?unitId=' + row.id, true) + '">' +
                                '<i class="fa-solid fa-share-alt fa-fw"></i>' +
                                '<span>' + Ptx.getMsg('menu.settings.linkToPosition') + '</span>' +
                            '</a>' +
                        '</li>';
                }
                if (row.authorities['ROLE_USER_LOGBOOK']) {
                	html +=
                        '<li>' +
                            '<a class="ptx-page-open" href="' + Ptx.url('/history/logbook.htm?filterUnitId=' + row.id, true) + '">' +
                                '<i class="fa-solid fa-book fa-fw text-primary"></i>' +
                                '<span>' + Ptx.getMsg('menu.logbook') + '</span>' +
                            '</a>' +
                        '</li>';
                }
                html +=
                    '<li>' +
                        '<a target="_blank" href="https://www.google.com/maps?q=' + row.lat + ',' + row.lon + '">' +
                            Ptx.html.icon({icon: "fa-google", cssClass: "fa-fw text-primary", faStyle: "brand"}) +
                            '<span>' + Ptx.getMsg('map.planRoute') + '</span>' +
                        '</a>' +
                    '</li>'
                if (row.authorities['ROLE_USER_GEOZONES']) {
                    html +=
                        '<li>' +
                            '<a class="ptx-show-modal" data-ptx-modal-size="modal-full" href="' + Ptx.url('/settings/geozones/geozones/insert.htm?unitId=' + row.id, true) + '">' +
                                '<i class="fa-solid fa-circle fa-fw text-primary"></i>' +
                                '<span>' + Ptx.getMsg('menu.unit.geozone') + '</span>' +
                            '</a>' +
                        '</li>';
                }
                + '<li class="divider"></li>';
            html += Ptx.html.smsCommands(row.id, row.smsTemplates, !(!!row.MSISDN)); //is MSISDN null/undefined/empty

            html += '</ul></div>';
            return html;
        }
    },
}

/**
 * Initialize data table (own function to prevent cache issue)
 * @alias Ptx.tables.map.init
 * @param {Object} data
 * @param ctx
 */
export function initMap(data, ctx) {
    /* setting column */
    var mapTable = $('#mapTable');
    Ptx.tables.map.col = [];
    Ptx.tables.map.order = [];

    if ( $('#unitId').val() == undefined || $('#unitId').val() == "" ) {
        Ptx.tables.map.unitId = null;
    } else {
        Ptx.tables.map.unitId = $('#unitId').val();
    }

    /* find settings by main table column */
    mapTable.find('thead th').each(function (i, elem) {
        var colset = mapColSettings[ $(this).data('name') ];

        if ( $(this).data('deforder') ) {
            Ptx.tables.map.order.push( [i, $(this).data('deforder')] );
        }

        var headset = {
            "data": $(this).data('name'),
            "orderable": $(this).data('sortable'),
            "visible": $(this).data('visible'),
        }

        Ptx.tables.map.col.push( $.extend( colset, headset ) );
    });

    // if unit id is not chosen, visible units id array is not needed
    if ( Ptx.tables.map.unitId != null ) {
        localStorage.removeItem("mapVisibleUnits");
    }

	var saveVisibleUnits = getSession("mapVisibleUnits");
	if (typeof saveVisibleUnits === "object" && saveVisibleUnits != null) {
		Ptx.tables.map.visibleUnits = saveVisibleUnits.visibleUnits;
		Ptx.tables.map.notVisibleUnits = saveVisibleUnits.notVisibleUnits;
	}

    drawMap(data, ctx);
    initSummaryComponents('#table-maps');
    //Ptx.tables.summary.initGroupFilter();
}

/**
 * Init datatables after create table on front-end
 * @alias Ptx.tables.map.draw
 * @param data
 * @param ctx
 */
export function drawMap(data, ctx) {
    var $table = $('#mapTable'),
        $datatable = {};

    $('#unitIgnition', ctx).off("change.table"); // multiple event trigger

    if (data == null) {
        data = Ptx.tables.map.data;
    }

    if ($.fn.DataTable.isDataTable($table)) { // table already exist
        $datatable = $table.DataTable();
        $datatable.clear().rows.add(data.units).draw();
    } else { // table doesn't exist yet
        $table.addClass('initDataTable');
        $datatable = $table.DataTable({
            "data": data.units,
            "deferRender": true,
            "dom": "t",
            "pageLength": -1,
            "autoWidth": false,
            "lengthMenu": [100, 200, 500, 1000, -1],
            "processing": true,
            responsive: {
                details: false
            },
            columns: Ptx.tables.map.col,
            "columnDefs": [
                { "targets": 4, "searchable": false }
            ],
            order: Ptx.tables.map.order,
            "initComplete": function (settings, json) {
                setTimeout(function () {
                    var e = jQuery.Event('keyup', {which: 13, keyCode: 13});
                    $('#searched').trigger(e);
                }, 250);
            },
            "drawCallback": function( settings ) {
                clearTimeout(Ptx.tables.drawCallbackDelay);
                Ptx.tables.drawCallbackDelay = delay(500, function(){
                    bulkResolve('trackPoint', ctx);
                    msgResolve(ctx);
                })
            }
        });
    }

    initChangeUnitIgnition(ctx, $datatable); // init events before trigger

    // Init search on keyup
    $('#searched', ctx).on('keyup', function () {
        $datatable.search(this.value).draw();
    });
}

/**
 * Initialize data table by dispatcher data json
 * @alias Ptx.tables.universal.init
 * @param colSettings
 * @param data
 * @param ctx
 * @param tableId
 * @param drawCallback
 */
export function initUniversal(colSettings, data, ctx, tableId, drawCallback) {
    /* setting column */
    Ptx.tables.universal.col = [];
    Ptx.tables.universal.order = [];

    var universalTable = $(tableId, ctx);
    /* find settings by main table column */
    universalTable.find('thead th').each(function (i) {
        var colset = colSettings[$(this).data('name')];

        if ($(this).data('deforder')) {
            Ptx.tables.universal.order.push([i, $(this).data('deforder')]);
        }

        var headset = {
            "data": $(this).data('name'),
            "orderable": $(this).data('sortable'),
            "visible": $(this).data('visible'),
        }

        var settings = $.extend(colset, headset);
        Ptx.tables.universal.col.push(settings);
    });
    drawUniversal(data, ctx, tableId, drawCallback);

    initSummaryComponents(tableId);
}

/**
 * build tables by the main table and draw
 * @alias Ptx.tables.universal.draw
 * @param data
 * @param ctx
 * @param tableId
 * @param drawCallback
 */
export function drawUniversal(data, ctx, tableId, drawCallback) {
    /* destroy datatable instances*/
    var oldTable = $('.initDataTable', ctx);
    var $table = $(tableId, ctx);
    oldTable.DataTable().destroy();
    //oldTable.remove();

    if (data == null) {
        data = Ptx.tables.universal.data;
    }

    $table.addClass('initDataTable');

    var universalSettings = {
        "data": data.tracePlanList,
        "deferRender": true,
        "dom": "t",
        "pageLength": 400,
        "autoWidth": false,
        "lengthMenu": [100, 200, 500, 1000, -1],
        "processing": true,
        "stateSave": true,
        "responsive": {
            details: false
        },
        "columnDefs": [{
            type: 'value-for-sort',
            targets: '_all',
        }],
        "columns": Ptx.tables.universal.col,
        "order": Ptx.tables.universal.order,
        "drawCallback": function(settings) {
            clearTimeout(Ptx.tables.drawCallbackDelay);
            Ptx.tables.drawCallbackDelay = delay(500, function() {
                bulkResolve('trackPoint', ctx);
                msgResolve(ctx);
                if (typeof drawCallback === "function") {
                    drawCallback()
                }
            })
        }
    }

    var table = $table.DataTable(universalSettings);
}

/**
 * Create datatables in given ctx
 * @alias Ptx.tables.init
 * @param ctx
 */
export function initTables(ctx) {
    try {
        if ( $('.table-data-summary-new', ctx).length > 0 ) {
            /*  ------------------  SUMMARY DATA TABLE ----------------------- */
            Ptx.tables.summary.url = getUrl('/summary/data.json?filterId=0');
            openWithParams( Ptx.tables.summary.url, 'GET', {sm_dec:'none'}, function (data) {
                Ptx.tables.summary.data = data;
                openWithParams('/summary/filterSettings.json', 'GET', null, function (groupSettings) {
                    if (groupSettings.groupingTypeId != null) {
                        Ptx.tables.summary.groupId = groupSettings.groupingTypeId;
                    }
                    initSummary( data, Ptx.tables.summary.groupId, ctx );
                });
            });

            var bodyHeight = getSession("summaryBodyHeight");
            if (bodyHeight) {
                $('body').css('min-height', bodyHeight);
            }

        } else {
            /*  ------------------  OTHER DATA TABLES ----------------------- */
			$('.table-data', ctx).each(function () {
				var $this = $(this);
				var ordering = true;
				var info = false;
				var col = [];
				var order = [];

				if (typeof $this.data('ordering') !== 'undefined') {
					ordering = $this.data('ordering');
				}

				if ($this.data('info')) {
					info = $this.data('info');
				}

				$this.find('thead th').each(function (i) {
					var th = $(this);
					var colspan = th.attr('colspan');

					var hasColspan = (typeof colspan !== 'undefined' && colspan !== false)
					if (!hasColspan) {
						if (th.data('deforder')) {
							order.push([i, th.data('deforder')]);
						}
						col.push({
							"data": th.data('name'),
							"orderable": th.data('sortable'),
						});
					}
				});

				var tableSettings = {
					"dom": 't',
					"autoWidth": false,
					"lengthMenu": [-1],
					"responsive": {
						details: false
					},
					"columnDefs": [{
						type: 'value-for-sort',
						targets: '_all',
					}, {
						searchable: false,
						targets: 'not-search'
					}],
					"columns": col,
					"ordering": ordering,
					"info": info,
					"order": order
				}


				var source = $this.data('remote-source');
				if (source) {
					tableSettings["ajax"] = {
						"url": source,
						"dataSrc": ""
					}
				}
				/* setting datatable */
				var table = $this.DataTable(tableSettings);

				// use in jsp
				Ptx.tables.afterInit(table);

				$(ctx).on('click', 'th input:checkbox', function () {
					var that = this;
					$(this).closest('table').find('tr > td:first-child input:checkbox').each(function () {
						this.checked = that.checked;
						$(this).closest('tr').toggleClass('selected');
					});
					var callback = $(that).data('callback');
					if (callback) {
						var call = getFunction(callback, window);
						call();
					}
				});

				$('#searched', ctx).on('keyup', function () {
					table.search(this.value).draw();
				});

				initChangeUnitIgnition(ctx, table);

				// Remove data table filter (remove automatic drow search input)
				$('.dataTables_filter', ctx).hide();

				// Automatic ID reorder for columns with the data-column-id attribute

				var tableNode = $(table.table().node());

				tableNode.find('th[data-column-id="true"]').each(function(){
					var t = tableNode.DataTable({
						columnDefs: [
							{
								targets: [$(this).index()],
								searchable: false,
								orderable: false,
							},
						],
						order: [[1, 'asc']],
					});

					t.on('order.dt search.dt', function () {
						let i = 1;

						t.cells(null, $(this).index(), { search: 'applied', order: 'applied' }).every(function (cell) {
							this.data(i++);
						});
					}).draw();
				});
			});
        }
    } catch (err) {
        console.error("Error init datatable " + err.message);
    }
}

/**
 * @alias Ptx.tables.calculateAverageColumnWidth
 * @param tables
 */
export function calculateAverageColumnWidth(tables) {
    var columnWidth = [];
    var columnMax = 0;
    var finWidth = [];

    tables.each(function (i) {
        $(this).find('tr th').each(function (e) {
            if (columnWidth[e] === undefined) {
                columnWidth[e] = 0;
            }
            columnWidth[e] += $(this).width();
        })
        columnMax++;
    });
    columnWidth.forEach(function (e, i) {
        finWidth[i] = e / columnMax;
    });
    tables.each(function (i) {
        $(this).find('tr th').each(function (e) {
            $(this).width(finWidth[e]);
        })
        columnMax++;
    });
}

/**
 * @alias Ptx.tables.calculateMaxColumnWidth
 * @param tables
 */
export function calculateMaxColumnWidth(tables) {
    var columnWidth = [];
    var columnMax = 0;
    tables.each(function (i) {
        $(this).find('tr th').each(function (e) {
            if (columnWidth[e] === undefined) {
                columnWidth[e] = 0;
            }
            if (columnWidth[e] < $(this).width()) {
                columnWidth[e] = $(this).width();
            }
        })
    });
    tables.each(function (i) {
        $(this).find('tr th').each(function (e) {
            $(this).width(columnWidth[e]);
        })
        columnMax++;
    });
}

/**
 * It insert new options to group select filter
 * @alias Ptx.tables.summary.fillGroupFilter
 */
export function fillGroupFilter(data, groupId) {
    var select = $('#groupFilter'+groupId);
    var $colorpicker = select.parent().find('.colorpicker-menu');
    var $chosen = select.parent().find('.chosen-container');

    // Remove old options
    select.find('option').each(function () {
        if ($(this).val()) {
            $(this).remove()
        }
    })

    if (groupId == 3) { //sort selections
	    var keys = [];
	    for (var key in data) {
	    	keys.push(key);
	    }

	    keys.sort(function(a,b) {
		  	a = a.replace(/\s/g, '').toLowerCase();
		  	b = b.replace(/\s/g, '').toLowerCase();
		  	if (a > b) return 1;
		  	if (a < b) return -1;
		  	return 0;
		});

	    var map = new Object();
	    $.each(keys, function( index, value ) {
	    	map[value] = data[value];
	    });

	    data = map;
	}

    // create new options by group Id
    var html = '';
    for (var key in data) {
        var groupKey, groupName;

        if (groupId == 1) {
            groupKey = data[key][0]['objectTypeId'];
            groupName = data[key][0]['icoNameI18n'];
        } else if (groupId == 2) {
            groupKey = '#' + data[key][0]['color'];
            groupName = '#' + data[key][0]['color'];
        } else if (groupId == 3) {
            groupKey = data[key][0]['userGroupId'];
            groupName = data[key][0]['userGroupName'];
        } else if (groupId == 4) {
            groupKey = data[key][0]['orderDestinationId'];
            groupName = data[key][0]['orderDestination'];
        }
        if (typeof groupKey !== "undefined" || groupKey != null){
        	html += '<option value="' + groupKey + '">' + groupName + '</option>';
        }
    }

    // insert options to select box
    select.append(html);

    select.attr('data-groupid', groupId);
    $('.groupFilter:not(.hidden)').addClass('hidden');
    select.parent().removeClass('hidden');

    var key = select.attr('data-groupid');

    if (Ptx.tables.summary.groupFilter) {
    	var v = Ptx.tables.summary.groupFilter;
    	if (key == 2) {
    		v = '#'+v;
    	}
    	select.val(v);
    }

    if (groupId != 0) {
        if (groupId == 2) {
			if($($colorpicker).length > 0) {
				select.trigger('change');
			} else {
				Ptx.fn.initColorPicker(select);
			}
        } else {
            if (isRtl()) {
                select.addClass('chosen-rtl');
        	}
            select.chosen({disable_search_threshold: 10});
            select.trigger("chosen:updated");
        }
    }

    showTablesByGroupFilter(select, Ptx.tables.summary.groupFilter);
}

/**
 * @alias Ptx.tables.summary.initGroupFilter
 */
export function initGroupFilter() {
	var select = $('#groupFilter1, #groupFilter2, #groupFilter3, #groupFilter4');
	select.on('change', function () {
		var key = $(this).attr('data-groupid');
		var val = $(this).val().replace("#", "");
		Ptx.tables.summary.groupFilter = val;
		openWithParams('/summary/selectedItem.json', 'POST', {'selectedItem': val}, function(data){});
		updateMinHeight();
		showTablesByGroupFilter($(this), val);
	});
}

/**
 * @alias Ptx.tables.summary.showTablesByGroupFilter
 * @param select
 * @param value
 */
export function showTablesByGroupFilter(select, value) {
    var key = select.attr('data-groupid');

    // show/hide tables by group id
    var tables = $('.initDataTable');
    if (value && key > 0) {
        tables.hide();
		let tableFilter = tables.filter('[data-group="' + value + '"]');
        tableFilter.show();

		if(tableFilter.length === 0) {
			$('#content').html('<div style=\'width: 100%; text-align: center;\'>'
			+ Ptx.getMsg('common.filter.units.none')
			+ '</div>');
		}
    } else {
        tables.show();
    }

    // selected right options by group id
    if (Ptx.tables.summary.groupFilter) {
        select.find('option').filter(function () {
            return $(this).val() == Ptx.tables.summary.groupFilter;
        }).prop('selected', true);
    }
}

/**
 * @alias Ptx.tables.stickyHeadersOverflowInModal
 * @param table
 */
export function stickyHeadersOverflowInModal(table) {
    var $modal = $('.modal');
    $modal.find('.overflow-desktop').scroll(function () {
        $modal.trigger('resize.stickyTableHeaders');
    })
}

/**
 * @alias Ptx.tables.fixedStickyHeadersInModal
 */
export function fixedStickyHeadersInModal() {
    var $modal = $('.modal');
    $modal.find('.modal-dialog').css('transform', 'none');
}

/**
 * @alias Ptx.tables.onSort
 * @param table
 * @param callback
 */
export function onSort(table, callback) {
    table.find('thead tr th').on('click', function () {
        var $self = $(this);
        delay(50, function () {
            var id = $self.attr('data-name');
            var sort = $self.attr('aria-sort');
            var order = 1;
            if (sort == 'descending') {
                order = 0;
            }
            if (typeof sort === 'string') {
                callback(id, order);
            }
        });
        return true;
    })
}

/**
 * @alias Ptx.tables.initIgnition
 * @param ctx
 * @param tables
 * @param unitState
 */
export function initIgnition(ctx, tables, unitState) {
	if (unitState != null) {
		$('.counterStat').removeClass('active');
		$("div[data-cname='" + unitState + "']").addClass('active');
	}
	var $select = $('#unitIgnition', ctx);
	var $option = $select.children("option[value='" + unitState + "']");

	if ($option.length > 0) {
        $select.val(unitState).trigger("chosen:updated");
    }
}

/**
 * Init search of ignition on change selectbox of ignition
 * @alias Ptx.tables.initChangeUnitIgnition
 */
export function initChangeUnitIgnition(ctx, tables) {
    $('.counterStat', ctx).on('click', function() {
        const $filterVal = $(this).data("cname"),
            searchedValue = $filterVal === "all" ? "" : $filterVal;
        if (Ptx.tables.unitIgnition !== $filterVal) {
            openWithParams('/summary/ignitionSettings.json', 'POST', { 'unitStateName': $filterVal });
        }
        $('.counterStat').removeClass('active');
        $(this).addClass('active');
        $('#unitIgnition').val($filterVal);
        tables.columns($(this).attr('data-column-id')).search(searchedValue).draw();
		Ptx.tables.unitIgnition = $filterVal;
        updateMinHeight();
    });
    $('#unitIgnition', ctx).on('change.table', function () {
        const $filterVal = $(this).val(),
            urlPrefix = $(this).attr('data-url'),
			searchedValue = $filterVal === "all" ? "" : $filterVal;
        if (Ptx.tables.unitIgnition !== $filterVal) {
            openWithParams('/' + urlPrefix + '/ignitionSettings.json', 'POST', {'unitStateName': $filterVal});
        }
		tables.columns($(this).data('column-id')).search(searchedValue).draw();
		Ptx.tables.unitIgnition = $filterVal;
        updateMinHeight();
    });
}

/**
 * @alias Ptx.tables.initStickyHeaders
 * @param table
 * @param settings
 */
export function initStickyHeaders(table, settings) {
    // init sticky table headers
    if (isDesktop()) {
        table.each(function () {
    	    var t = $(this);
    	  	if (!t.hasClass('no-sticky-headers')) {
    	  		t.stickyTableHeaders(settings);
    	  		fixedStickyHeadersInModal();
    	  		stickyHeadersOverflowInModal();
    	  	}
        })
    }
}

/**
 * @alias Ptx.tables.initTableHeader
 * @param ctx
 */
export function initTableHeader(ctx){
	var $tables = $('.ptx-table', ctx);
	var $scroller = $tables.closest(".scroller-content");

    if ($scroller.length == 1) {
    	initStickyHeaders($tables, {scrollableArea: $scroller[0]});
    } else {
        initStickyHeaders($tables, {fixedOffset: 50});
    }
}

/**
 * @alias Ptx.tables.updateMinHeight
 */
export function updateMinHeight() {
    const $body = $("body"), $height = $('#demo-page', $body).height();
	$body.css("min-height", $height);	//set actual min height - because reload
    setSession("summaryBodyHeight", $height);
}

/**
 * @alias Ptx.fn.initToggleStatTable
 * @param exportOption Optional value came from back-end (ProviderParams.statisticsParameters.statisticExportOption)
 */
export function initToggleStatTable(exportOption) {
	const statTableWrapper = $('.stat-table-wrapper');
	const statContainerToggle = $('#stat-container-toggle');

    // Hide the toggle if .stat-table-wrapper doesn't exist or exportOption not exist.
	if (statTableWrapper.length === 0 || !exportOption) {
		statContainerToggle.hide();
        return;
	}
    let isToggled = false;
    if (exportOption) {
        isToggled = exportOption === 'ALL' || exportOption === 'ONLY_TABLE'
    }
	$(".slider", statContainerToggle).on('click', function (event) {
		event.stopPropagation();
        isToggled = !isToggled;
        const targetHeight = isToggled ? statTableWrapper.prop('scrollHeight') : 0;
        statTableWrapper.css('height', targetHeight);
	});
    showHideStatTable(isToggled);
}

/**
 * Show or hide table in statistics according to parameter isToggled.
 * @param isToggled if is true then table will be showed up and toggle button will be rendered in on state.
 */
export function showHideStatTable(isToggled) {
    // console.log("showHideStatTable(" + isToggled + ")");
    // Shor or hide table with statistics.
    const statTableWrapper = $('.stat-table-wrapper');
    if (statTableWrapper.length === 0) {
        return;
    }
    /**
     * For functionality of button for show/hide of table in statistics is necessary to set height of the div.stat-table-wrapper
     * but printing to pdf via stat-export has different behaviour and set size of this div is smaller than table! This leads
     * to common problem that all tables has unnecessary vertical scrollbar in created pdf, so few lines of table wasn't printed!
     * A functional solution is to removed attribute "height" from div.stat-table-wrapper if the table is to be printed
     * and set value of this attribute to 0 if not.
     */
    if (isToggled) {
        statTableWrapper.removeAttr('height');
    } else {
        statTableWrapper.css('height', 0);
    }
}